// WP4 (audit pwreset-1 / pwreset-5): pure decisions behind ChangePasswordSection
// and ForcePasswordChangeGate, kept out of the components so they are testable.

export const MIN_PASSWORD_LENGTH = 8;

export function validateNewPassword(password: string, confirm: string): string | null {
  if (password.length < MIN_PASSWORD_LENGTH) return `Use at least ${MIN_PASSWORD_LENGTH} characters.`;
  if (password !== confirm) return "Passwords do not match.";
  return null;
}

const CHANGE_ERROR_COPY: Record<string, string> = {
  "auth/wrong-password": "Current password is incorrect.",
  "auth/invalid-credential": "Current password is incorrect.",
  "auth/weak-password": `Choose a stronger password (at least ${MIN_PASSWORD_LENGTH} characters).`,
  "auth/requires-recent-login": "Sign out, sign back in, and try again.",
  "auth/too-many-requests": "Too many attempts. Wait a few minutes and try again.",
};

/** Human copy for a failed reauthenticate / updatePassword call. Never returns an `auth/...` code. */
export function describePasswordChangeError(err: unknown): string {
  const code = (err as { code?: unknown } | null | undefined)?.code;
  if (typeof code === "string" && CHANGE_ERROR_COPY[code]) return CHANGE_ERROR_COPY[code];
  return "Could not change the password. Try again in a moment.";
}

export function hasPasswordProvider(providerIds: string[]): boolean {
  return providerIds.includes("password");
}

/**
 * D8: only client org admins are made to replace the emailed temporary password.
 * Platform roles sign in with Google. Impersonation produces a synthetic org role
 * on top of a real platform login, so it never triggers the gate either.
 */
export function shouldForcePasswordChange(args: {
  role: string | null | undefined;
  mustChangePassword: boolean | undefined;
  providerIds: string[];
  isImpersonating: boolean;
}): boolean {
  if (args.isImpersonating) return false;
  if (args.role !== "ORG_OWNER" && args.role !== "ORG_ADMIN" && args.role !== "ORG_REQUESTER") return false;
  if (args.mustChangePassword !== true) return false;
  return hasPasswordProvider(args.providerIds);
}
